import { Auth0ContextInterface } from "@auth0/auth0-react";
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import {
  ViAxiosError,
  ViEnvVariableNotSetError,
  ViError,
  ViUserNotAuthenticatedError,
} from "../models/Errors";

class PartsterClient {
  authContext?: Auth0ContextInterface;
  axios?: AxiosInstance;
  baseURL?: string;
  audience: string;
  threshold: number;
  userId?: string;
  AuthContext?: Auth0ContextInterface;

  constructor() {
    this.threshold = parseFloat(process.env.REACT_APP_PARTSTER_THRESHOLD || "0.4");
    this.audience = process.env.REACT_APP_PARTSTER_AUTH0_AUDIENCE || "ptb-dev";
    this.baseURL = process.env.REACT_APP_PARTSTER_BASE_URL;
  }

  init(AuthContext: Auth0ContextInterface, baseURL?: string): PartsterClient {
    try {
      if (baseURL) this.baseURL = baseURL;
      if (!this.baseURL)
        throw new ViEnvVariableNotSetError("REACT_APP_PARTSTER_BASE_URL");
      if (!AuthContext.isAuthenticated) throw new ViUserNotAuthenticatedError();
      this.AuthContext = AuthContext;
      this.axios = axios.create({ baseURL: this.baseURL });
      return this;
    } catch (e) {
      throw e;
    }
  }

  async req({ headers, ...config }: AxiosRequestConfig): Promise<AxiosResponse<any>> {
    if (!this.axios) throw new ViError("PartsterClient has not been initialized.");
    headers = {
      ...headers,
      Authorization: `Bearer ${await this.AuthContext?.getAccessTokenSilently()}`,
    };
    try {
      const response = this.axios?.request({ headers, ...config });
      return response;
    } catch (e) {
      throw new ViAxiosError(e);
    }
  }

  async getBundleParts(
    sgns: string[],
    soleraModelId?: string,
    threshold?: number
  ): Promise<any> {
    const data = {
      inputThresh: threshold || this.threshold,
      inputSgnList: sgns,
      rows: 10,
      ...(soleraModelId ? { vehicleDetails: { soleraModelId } } : {}),
    };
    const response = await this.req({
      method: "post",
      url: `/v1/partster/parts`,
      data,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  }
}

const PartsterClientInstance: PartsterClient = new PartsterClient();
export default PartsterClientInstance;
